// src/environments/environment.ts
export const environment = {
  production: false,
  apiKey: 'AIzaSyC1p-oJ8zHQwxJkhqQqheCAWMLjgQ8La_k',
};

export const API = {
  production: false,
  apiUrl:
    'https://titwmo9dek.execute-api.ap-southeast-2.amazonaws.com/members/',
};
